/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  invoiceList: [],
  period:{
    // PeriodId:'0',
    // Week:'0',
    // Month:'0',
    // Year:'0',
    // BeginDate: "MM-DD-YYYY",
    // EndDate: "MM-DD-YYYY",
    // ExchangeRate: "1.0000"
    // updated: false
  }
}
